<template>
    <div class="cpt-calendar-wrap">
      <t-calendar ref="myCalendar" 
        class="myCalendar"
        theme="card" 
        :controller-config="controllerConfig"
        :format="option.attribute.dateFormat" 
        :multiple="option.attribute.multiple" 
        :style="setStyles"
        :value="checkedVal"
        @cell-click="onchange"
        />
    </div>
</template>
<script>
import { getDefaultValue } from "@/utils/refresh-cpt-data"; // 默认值方法

// import {
//   Calendar as MCalendar,
// } from "tdesign-vue-next";
export default {
  name: "cpt-calendar",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
  },
  components: {
    // "m-calendar": MCalendar,
  },
  data() {
    return {
      checkedVal:"20240104",
      multiple: false,//多选
      message: "default",
      tips: "",
      uuid:null,
    }
  },
  watch: {
    //监控日期范围  
    // 'option.attribute': {
    //   handler(obj) {
    //     this.multiple = obj.multiple;
    //     const defaultValue = getDefaultValue(obj, 'cpt-calendar');
    //     if (defaultValue) {
    //       console.log(defaultValue, 'defaultValue')
    //       let str;
    //       if (Array.isArray(defaultValue)) {
    //         // 转换数组元素
    //         str = defaultValue.map(item => typeof item == 'undefined' ? item : String(item));
    //         console.log(str); // 输出: ["2024", undefined]
    //       }
    //       obj.multiple ? this.checkedValDate = str : this.checkedVal = defaultValue.toString();
    //     }
    //   },
    //   deep: true
    // },
    checkedVal: {
      handler(val){
        if(val){
          console.log(val,'ccccccccccc');
          this.clickHandler()
        }
      }
    }
  },
  computed: {
    controllerConfig () {
      return {
        visible: true,
        disabled: false, // 是否禁用（全部控件）
        // 年份选择框组件相关设置
        year: {
          visible: true, // 是否显示
          selectProps: {
            // 用于透传props给该select组件
            disabled: false,
            size: 'small',
            popupProps: {
              overlayClassName:'calendarPop',
              // attach:'.myCalendar'
            }
          },
        },
        // 月份选择框组件相关设置
        month: {
          visible: true, // 是否显示（“year”模式下本身是不显示该组件的）
          selectProps: {
            // 用于透传props给该select组件
            disabled: false,
            size: 'small',
            popupProps: {
              overlayClassName:'calendarPop',
              // attach:'.myCalendar'
            }
          },
        },
        // 模式切换单选组件设置
        mode: {
          visible: true, // 是否显示
          radioGroupProps: {
            disabled: false,
            size: 'small',
          },
        },

      }
    },
    setStyles() {
      return {
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor":this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--align": this.option.attribute.align,
        "--timeIcon": this.option.attribute.timeIcon ? 'block' : 'none',
        "--direction": this.option.attribute.direction,
        "--itembgColor": this.option.attribute.bgColor,
        "--itemFontColor": this.option.attribute.textColor,
        "--activeColor": this.option.attribute.activeColor,
        "--activeBrColor": this.option.attribute.activeBrColor,
        "--activeBgColor": this.option.attribute.activeBgColor,
        "--nowBgColor": this.option.attribute.nowBgColor,
        "--nowBrColor": this.option.attribute.nowBrColor,
        "--nowColor": this.option.attribute.nowColor,
        // "--selectBgColor": this.option.attribute.selectBgColor,
        // "--selectBrColor": this.option.attribute.selectBrColor,
        // "--selectColor": this.option.attribute.selectColor,
        // "--selectActiveBgColor": this.option.attribute.selectActiveBgColor,
        // "--selectActiveBrColor": this.option.attribute.selectActiveBrColor,
        // "--selectActiveColor": this.option.attribute.selectActiveColor,

        "--td-bg-color-container": this.option.attribute.bgColor,
        "--td-border-level-1-color" :this.option.attribute.bgColor,
        "--td-text-color-primary": this.option.attribute.textColor,
        "--td-bg-color-component": this.option.attribute.activeBgColor, 
        "--td-bg-color-container-select": this.option.attribute.bgColor,
        "--td-bg-color-container-hover": this.option.attribute.bgColor, 
        "--td-brand-color-ligh": '#f2f3ff', 
       







      }
    },
  },
  mounted() {
    this.multiple = this.option.attribute.multiple;
    const defaultValue = getDefaultValue(this.option.attribute, 'cpt-calendar')
    if (defaultValue) {
      console.log(defaultValue, 'defaultValue')
      let str;
      if (Array.isArray(defaultValue)) {
        // 转换数组元素
        str = defaultValue.map(item => typeof item == 'undefined' ? item : String(item));
        console.log(str); // 输出: ["2024", undefined]
      }
      this.checkedVal = defaultValue;
    }
  },
  created() {
     this.uuid = require("uuid").v1();
    //  this.refreshCptData(this.option.cptDataForm);
  },
  methods: {
    onchange(val){
      debugger;
      let vm = this;
      let { multiple,dateFormat} = vm.option.attribute;
      let value = val.cell.date;
      let arr = null;
      switch (dateFormat) {
        case 'YYYY':
          value = value.getFullYear()
          break;
        case 'YYYY-MM':
          arr = val.cell.date.toLocaleString().split('/')
          value = arr[0] + '-' +  arr[1]
          break;
      
        case 'YYYY-MM-DD':
          arr = val.cell.date.toLocaleDateString().split('/')
          value = arr[0] + '-' +  arr[1] + '-' + arr[2]
          break;
      
        default:
          arr = val.cell.date.toLocaleString().split('/')
          value = arr[0] + '-' +  arr[1] + '-' + arr[2]
          break;
      }
      if(multiple){
        this.setValue([...this.checkedVal,value])
      }else {
        
        this.setValue(value)
      }
      

    },
    clickHandler() {
      debugger
      this.$emit("clickHandler", this.option.interaction, 'default', this.checkedVal, 'cpt-calendar')
      this.checkValue();
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      console.log(this.checkedVal, 'this.checkedVal')
      if (attribute.required && !this.checkedVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
    getValue() {
      return this.checkedVal
    },
    setValue(value) {
      console.log(value, this.option.attribute.multiple ,'东山口大声道')
      this.checkedVal = value
    },

  }
}
</script>
<style>
.calendarPop {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #000;
}
.calendarPop >.t-popup__content {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #000;

}
.calendarPop .t-select-option {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #000;
}
.calendarPop .t-popup__content::-webkit-scrollbar {
    width: 0px !important; /* 滚动条宽度 */
}
</style>
<style scoped>
.cpt-calendar-wrap {
  width:100%;
  height:100%;
}
.cpt-calendar-wrap /deep/.t-calendar--full,.cpt-calendar-wrap /deep/.t-calendar--card{
  min-width: 300px;
  min-height: 300px;
  padding: 20px;
}
.cpt-calendar-wrap /deep/ .t-calendar {
  width: 100%;
  height: 100%;
  font-size: var(--fontSize);
  color: var(--textColor);
  background-color:var(--bgColor);
  border: var(--borderSize) var(--lineType) var(--borderColor);
  border-radius: var(--borderRadius);
}
.cpt-calendar-wrap /deep/ .t-calendar__panel.t-calendar__panel--month {
  height: 80%;
}
.cpt-calendar-wrap /deep/ .t-calendar__table-body-cell-display {
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  color: var(--textColor);
}
.cpt-calendar-wrap /deep/.t-is-checked>.t-calendar__table-body-cell-display {
  color: var(--activeColor);
  border-color: var(--activeBrColor);
  background-color: var(--activeBgColor); 
}
.cpt-calendar-wrap /deep/ .t-calendar__table-body-cell--now>.t-calendar__table-body-cell-display {
  font-size: var(--fontSize);
  color: var(--nowColor);
  border-color: var(--nowBrColor);
  background-color: var(--nowBgColor);
}
.cpt-calendar-wrap /deep/ .t-input.t-size-s{
  font-size: var(--fontSize);
}
.cpt-calendar-wrap /deep/ .t-input__inner{
  width: 50px;
}
.cpt-calendar-wrap /deep/ .t-select .t-fake-arrow {
  color: var(--textColor);
}
.cpt-calendar-wrap /deep/ .t-calendar__control-section-cell:nth-child(1) .t-input--auto-width{
  min-width: 120px;
}
.cpt-calendar-wrap /deep/ .t-calendar__control-section-cell:nth-child(2) .t-input--auto-width{
  min-width: 80px;
}


</style>

